import BASE_URL from "../Services/AxiosInstance"

export const API_ENDPOINTS = {
  

//////////////////////////////////////PROJECT URLS /////////////////////////////////////

  GET_PROJECTS_NAME: "/api/Projects/getProjects",
  


//////////////////////////////////////TASK URLS /////////////////////////////////////
GET_TASKS_REPORT: "/getTasklisting",
  ADD_TASK: "/api/Tasks/AddTask",
  
  UPDATE_TASK: "/api/Tasks/updateTask",
  GET_TASKS_BY_USERID: "/GetTaskListById",
  GET_TASKS_BY_PROJECTID: "/GetTaskListById",
  GET_TASKS_ONLOAD: "/getTasksOnload",


  GET_TASK_HISTORY:"/taskhistory",

  ///////////////////////////////////// status /////////////////////////////////////
  GET_STATUS: "/status",
  GET_PRIORIIY:"/priority",
  GET_ROLE:"/ROLE" ,


  POST_BUG:"/api/Bugs/addBug",

GET_BUG_UNDERTASKS:"/TaskBug",
  GET_USER_NAME:"/api/Users/getUserName"
};